import "@reach/tooltip/styles.css";
import "focus-visible/dist/focus-visible.js";
import { Boot } from "./src/Theme";

export const wrapRootElement = Boot

